const dollarStringToNumber = dollarString => {
  if (typeof dollarString === 'number') return dollarString

  if (typeof dollarString !== 'string') {
    console.error('`dollarStringToNumber` input must be a string or number')
    return
  }

  // error if not money string
  if (!dollarString.match(/^\$[\d,]+(\.\d\d)?$/)) {
    console.error('Not a valid money string, "$X,XXX.XX" or $X,XXX')
  }

  if (dollarString.match(/\.\d*/)) {
    // if format is $XX.XX
    return new Number(dollarString.replace(/\$|,|\./gi, '')) / 100
  } else {
    // if format is $XX
    return new Number(dollarString.replace(/\$|,/gi, ''))
  }
}

export const CurrencyUSD = (props) => {
  let {
    amount,
    nullCase
  } = props

  nullCase = nullCase ? nullCase : ""

  if(typeof amount === 'string' && amount[0] === '$') {
    return amount
  }

  amount = parseFloat(amount)

  if (!isNaN(amount)) {
    return amount.toLocaleString("en-us", {
      style: "currency",
      currency: "USD"
    })
  }
  return nullCase
}

export default CurrencyUSD
export { dollarStringToNumber }